const houseMaidDetailedRateCard = {
  key: "house-maid",
  title: "House Maid Detailed Rate Card",
  note:
    "Indicative maid pricing. Monthly cost depends on house size, number of tasks, timing, city, and whether support is once or twice daily.",
  sections: [
    {
      title: "One-time Visits",
      items: [
        { name: "One-time maid visit", price: "₹399 onwards" },
        { name: "One-time cleaning + utensils", price: "₹599 onwards" },
      ],
    },
    {
      title: "Monthly Support",
      items: [
        { name: "Dusting + sweeping + mopping", price: "₹1499-₹3999 per month" },
        { name: "Utensil cleaning only", price: "₹999-₹2499 per month" },
        { name: "Cleaning + utensils bundle", price: "₹2499-₹5499 per month" },
      ],
    },
  ],
};

export default houseMaidDetailedRateCard;